import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { Toaster } from "./ui/sonner";
import { DemoPrompt } from "./DemoPrompt";
import { CookieConsent } from "./CookieConsent";

export const Layout = ({ children }) => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) {
          const top = el.getBoundingClientRect().top + window.scrollY - 96;
          window.scrollTo({ top, behavior: "smooth" });
        }
      }, 80);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-700 flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <DemoPrompt />
      <CookieConsent />
      <Toaster theme="light" position="bottom-right" richColors />
    </div>
  );
};
